/**
 * Scripts
 */
import 'vite/modulepreload-polyfill'
import "lazysizes"
import { startupTheme } from "./js/theme"

// Import modules
import './js/toggle'
import './js/homeSlider'
import './js/videoPlayer'
import './js/menus'
import './js/search'
import './js/widget'
import './js/header'
import './js/contentNav'
import './js/map'

// Import node modules
// import 'swiper/css'
// import 'swiper/css/navigation'
// import 'swiper/css/pagination'

import './sass/main.sass'

/**
 * Start Theme
 */
startupTheme()
